<script setup>
import {onBeforeMount} from 'vue';
import {RMModal} from 'redmine-ui-kit';

import {useModalBus} from '@/core/composables/useModalBus';

const {closeModal} = useModalBus();

const props = defineProps({
    modalData: {
        type: Object,
        required: true,
    },
    isActive: {
        type: Boolean,
        default: () => false,
    },
});

function handleConfirm() {
    props.modalData.callback();
    handleClose();
}

function handleClose() {
    closeModal(props.modalData.template);
}

onBeforeMount(() => {
    if (!props.modalData.text || !props.modalData.callback) {
        handleClose();
    }
});
</script>

<template>
    <RMModal
        :is-active="isActive"
        transition-name="modal-fade"
        @close="closeModal(modalData.template)"
    >
        <div class="confirm-modal">
            <div class="confirm-modal-text">
                {{ modalData.text }}
            </div>
            <div class="confirm-modal-actions">
                <button @click="handleConfirm">
                    {{ $t('label_yes') }}
                </button>
                <button @click="handleClose">
                    {{ $t('label_no') }}
                </button>
            </div>
        </div>
    </RMModal>
</template>

<style lang="scss">
.confirm-modal {
    min-width: 300px;
    max-width: 600px;

    &-text {
        margin-bottom: 32px;
        font-size: 16px;
    }

    &-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 16px;

        > button {
            cursor: pointer;
        }
    }
}
</style>
